import { render } from "./NewPayment.vue?vue&type=template&id=564f31e2&scoped=true"
import script from "./NewPayment.vue?vue&type=script&lang=js"
export * from "./NewPayment.vue?vue&type=script&lang=js"

import "./NewPayment.vue?vue&type=style&index=0&id=564f31e2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-564f31e2"]])

export default __exports__